import React, { useState } from 'react';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon } from '@hydra/common/components';
import HighlightedCode from '@hydra/common/components/HighlightedCode';

import { useCopyToClipboard, useI18n } from '@hydra/common/customHooks';

import { sendEvent } from '@hydra/utils/gtm';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    width: '100%',
    '& pre': {
      minHeight: '60px'
    }
  },
  copyBtn: {
    background: theme.palette.grey[100],
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(1),
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius * 35,
    flexShrink: 0
  },
  copyText: {
    fontWeight: theme.typography.fontWeightSemibold,
    marginLeft: theme.spacing(1)
  }
}));

type CodeSnippetProps = {
  codeTag: string,
  language?: string,
  copyToClipboard?: boolean
  copyEvent?: string
}

function CodeSnippet ({ codeTag = '', language = 'js', copyToClipboard = false, copyEvent = '' }: CodeSnippetProps) {
  const classes = useStyles(copyToClipboard);
  const { setCopyToClipboard } = useCopyToClipboard();
  const { translate } = useI18n();
  const copy = translate('assistant_tab_copy');
  const copied = translate('assistant_tab_copied');
  const [statusText, setStatusText] = useState(copy);

  return (
    <div className={classes.root}>
      <HighlightedCode codeTag={codeTag} language={language} />
      {copyToClipboard && (
        <Button
          size='small'
          variant='contained'
          onClick={() => {
            copyEvent && sendEvent(copyEvent);
            setCopyToClipboard(codeTag);
            setStatusText(`${copied}!`);
          }}
          className={classes.copyBtn}
        >
          <Icon type='page-content' size='md' />
          <span className={classes.copyText}>{statusText}</span>
        </Button>
      )}
    </div>
  );
}

export default CodeSnippet;
